import styled from '@emotion/styled';

import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';

import { ReactComponent as Help } from '../ui/icons/help.svg';

import { Project } from '@arra/core';
import { useTranslation } from 'react-i18next';
import CompletionBar from '../project/CompletionBar';

const CompletionContainer = styled.div`
  width: 200px;
  display: flex;
  align-items: center;
  align-self: flex-start;
  gap: 8px;
  position: relative;
`;

const Right = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  justify-content: space-between;
`;

const TopRight = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

const Completion = ({
  project,
  onClick,
}: {
  project: Project;
  onClick: () => void;
}) => {
  const { t } = useTranslation(['project']);

  const hasRequiredFields = project.model.hasRequiredFields;
  const completionRate = project.completionRate;

  return (
    <CompletionContainer>
      {!hasRequiredFields ? (
        null
      ) : completionRate === 100 ? (
        <CheckCircleOutlineOutlinedIcon color="success" fontSize="large" />
      ) : (
        <ScheduleOutlinedIcon color="warning" fontSize="large" />
      )}
      <Right>
        <TopRight>
          <p className="h5b">{project.completionRate}%</p>
          <p className="hzr">{t('project:completion.label')}</p>
        </TopRight>
        <CompletionBar completionRate={completionRate} width="100%" />
      </Right>
    </CompletionContainer>
  );
};

export default Completion;
